module.exports = __webpack_public_path__ + "img/3.99ac8651.jpg";